var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.233 1.375h6.533a.458.458 0 0 1 .371.189l1.752 2.409a.23.23 0 0 1-.016.29L5.668 9.901a.23.23 0 0 1-.336 0L.127 4.263a.23.23 0 0 1-.017-.29l1.753-2.41a.458.458 0 0 1 .37-.188Z",
    fill: "#E85143"
  })));
};

export default SvgDiamond;